const requestJabatansType = 'REQUEST_JABATANS';
const receiveJabatansType = 'RECEIVE_JABATANS';
const initialState = { jabatans: [], isLoading: false };

export const actionCreators = {
    requestJabatans: (startDateIndex, values) => async (dispatch, getState) => {
        if (startDateIndex === getState().jabatans.startDateIndex) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
             return;
        }
        dispatch({ type: requestJabatansType, startDateIndex });

            const url = `api/SampleData/helo`;
            const request = new Request(url, {
                method: 'post',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(values)
            });
            const response = await fetch(request);
            const jabatans = await response.json();
        dispatch({ type: receiveJabatansType, startDateIndex, jabatans });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestJabatansType) {
        return {
            ...state,
            startDateIndex: action.startDateIndex,
            isLoading: true
        };
    }

    if (action.type === receiveJabatansType) {
        return {
            ...state,
            startDateIndex: action.startDateIndex,
            jabatans: action.jabatans,
            isLoading: false
        };
    }

    return state;
};


// WEBPACK FOOTER //
// ./src/store/Jabatans.js